/** Detect whether canvas pixel reads are allowed (CORS / taint). */
export function canReadCanvasPixels(canvas: HTMLCanvasElement | OffscreenCanvas): boolean {
  const ctx = canvas.getContext('2d');
  if (!ctx) return false;
  try {
    ctx.getImageData(0, 0, 1, 1);
    return true;
  } catch {
    return false;
  }
}

/** Approximate color grade without pixel reads (preview fallback). */
export function applyCssColorGrade(
  ctx: CanvasRenderingContext2D,
  source: CanvasImageSource,
  w: number,
  h: number,
  params: Record<string, number>,
): void {
  const exposure = Math.pow(2, params.exposure ?? 0);
  const contrast = params.contrast ?? 1;
  const sat = params.saturation ?? 1;
  const temp = params.temperature ?? 0;
  const brightness = exposure;
  const sepia = Math.max(0, temp) * 0.15;
  const hue = temp * 8;
  ctx.filter = [
    `brightness(${brightness})`,
    `contrast(${contrast})`,
    `saturate(${sat})`,
    `sepia(${sepia})`,
    `hue-rotate(${hue}deg)`,
  ].join(' ');
  ctx.drawImage(source, 0, 0, w, h);
  ctx.filter = 'none';
}
